import { FirebaseError } from "firebase/app";

/**
 * Firebase Auth error codes → copy a contractor can act on.
 *
 * Modern Firebase projects collapse "wrong password" and "no such account"
 * into a single `auth/invalid-credential` to stop attackers enumerating
 * accounts, so the sign-in copy deliberately never says which half failed.
 */
const MESSAGES: Record<string, string> = {
  "auth/invalid-credential": "That email and password don't match. Check both and try again.",
  "auth/wrong-password": "That email and password don't match. Check both and try again.",
  "auth/user-not-found": "That email and password don't match. Check both and try again.",
  "auth/invalid-email": "That doesn't look like a valid email address.",
  "auth/missing-password": "Enter your password.",
  "auth/user-disabled": "This account has been disabled. Contact Shoku support to reopen it.",
  "auth/too-many-requests":
    "Too many attempts. Wait a few minutes before trying again, or reset your password.",
  "auth/network-request-failed": "We couldn't reach Shoku. Check your connection and try again.",
  "auth/weak-password": "Choose a password of at least 8 characters.",
  "auth/operation-not-allowed": "Email sign-in isn't enabled for this project. Contact support.",
  "auth/requires-recent-login": "For security, sign in again before making this change.",
};

export function firebaseErrorCode(error: unknown): string {
  return error instanceof FirebaseError ? error.code : "";
}

export function firebaseAuthMessage(error: unknown, fallback = "Something went wrong. Please try again."): string {
  const code = firebaseErrorCode(error);
  if (code && MESSAGES[code]) return MESSAGES[code]!;
  if (error instanceof FirebaseError) return fallback;
  if (error instanceof Error && error.message) return error.message;
  return fallback;
}

/** Both Shoku apps share one Auth pool, so this one needs its own treatment. */
export function isEmailInUse(error: unknown): boolean {
  return firebaseErrorCode(error) === "auth/email-already-in-use";
}
